
export { useAmplitude } from "/__w/wiggot-web/wiggot-web/packages/analytics/src/providers/amplitud-provider/AmplitudeProvider.tsx"